import { gql } from "apollo-boost";

export const GET_FACULTY = gql`
  query getFaculty($id: ID!) {
    getFaculty(
      id: $id
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const GET_FACULTIES = gql`
  query getFaculties {
    getFaculties {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const ADD_FACULTY = gql`
  mutation addFaculty(
    $code: String!,
    $nameLocal: String!,
    $nameEng: String
  ) {
    addFaculty (
      code: $code,
      nameLocal: $nameLocal,
      nameEng: $nameEng
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const UPDATE_FACULTY = gql`
  mutation updateFaculty(
    $id: ID!,
    $code: String!,
    $nameLocal: String!,
    $nameEng: String
  ) {
    updateFaculty (
      id: $id,
      code: $code,
      nameLocal: $nameLocal,
      nameEng: $nameEng
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

export const DELETE_FACULTY = gql`
  mutation deleteFaculty(
    $id: ID!
  ) {
    deleteFaculty (
      id: $id
    ) {
      id
      code
      nameLocal
      nameEng
    }
  }
`;

